<script>
  import { scaleLinear, scaleTime } from 'd3-scale'
  import { max, extent } from 'd3-array'
  import { onMount } from 'svelte'
  import { formatThousands, formatDateLong } from './functions'
  let vaxhosp = []
  let ward = []
  let intensivecare = []
  let highcare = []
  let national = []
  let total
  let width
  let height = 150
  let offsetLeft = 150
  let latestDate
  async function getVaxHosp() {
    await fetch('https://api.mediahack.co.za/outlier/vax-hospitals.php')
      .then((response) => response.json())
      .then((res) => {
        let response = res.filter((d) => d.date !== '')
        console.log(response)

        latestDate = response[response.length - 1].date
        vaxhosp = response.filter((d) => d.date === latestDate)
        console.log(vaxhosp)
        ward = vaxhosp.filter((d) => d.type === 'Ward')[0]
        intensivecare = vaxhosp.filter(
          (d) => d.type === 'Intensive Care Unit'
        )[0]
        national = vaxhosp.filter((d) => d.type === 'National')[0]
        highcare = vaxhosp.filter((d) => d.type === 'High Care Unit')[0]

        ward.partially_vaccinated = +ward.partially_vaccinated
        ward.fully_vaccinated = +ward.fully_vaccinated
        ward.not_vaccinated = +ward.not_vaccinated

        // intensivecare.forEach((d) => {
        //   d.partially_vaccinated = +d.partially_vaccinated
        //   d.fully_vaccinated = +d.fully_vaccinated
        //   d.not_vaccinated = +d.not_vaccinated
        // })
        // highcare.forEach((d) => {
        //   d.partially_vaccinated = +d.partially_vaccinated
        //   d.fully_vaccinated = +d.fully_vaccinated
        //   d.not_vaccinated = +d.not_vaccinated
        // })

        console.log(ward)
        console.log(highcare)
        console.log(intensivecare)
        console.log(national)
        total =
          +national['partially_vaccinated'] +
          +national['fully_vaccinated'] +
          +national['not_vaccinated']

        console.log(total)
      })
  }
  onMount(() => {
    getVaxHosp()
  })

  $: scaleX = scaleLinear()
    .domain([0, total])
    .range([0, width - offsetLeft])
</script>

<div class="chart-wrap">
  <div class="chart-title">SA Hospitalisations and Vaccination Status</div>

  <div class="latest-date">Updated: {latestDate}</div>

  <div class="chart chart-vax-cases chart-block" bind:clientWidth={width}>
    <!-- Vaxxinations versus Hospitals table -->
    <div class="table">
      <table>
        <tr>
          <th /><th style="background: #87B7D4;">Fully Vaccinated</th><th
            style="background: #FFDB5A;">Partially Vaccinated</th
          ><th style="background: #D9918F;">Not Vaccinated</th>
        </tr>
        <tr>
          <td>In Wards</td>
          <td style="background: #87B7D4;"
            >{formatThousands(ward['fully_vaccinated'])}</td
          >
          <td style="background: #FFDB5A;"
            >{formatThousands(ward['partially_vaccinated'])}</td
          >
          <td style="background: #D9918F;"
            >{formatThousands(ward['not_vaccinated'])}</td
          >
        </tr>

        <tr>
          <td>In High Care</td>
          <td style="background: #87B7D4;"
            >{formatThousands(highcare['fully_vaccinated'])}</td
          >
          <td style="background: #FFDB5A;"
            >{formatThousands(highcare['partially_vaccinated'])}</td
          >
          <td style="background: #D9918F;"
            >{formatThousands(highcare['not_vaccinated'])}</td
          >
        </tr>

        <tr>
          <td>In Intensive Care</td>
          <td style="background: #87B7D4;"
            >{formatThousands(intensivecare['fully_vaccinated'])}</td
          >
          <td style="background: #FFDB5A;"
            >{formatThousands(intensivecare['partially_vaccinated'])}</td
          >
          <td style="background: #D9918F;"
            >{formatThousands(intensivecare['not_vaccinated'])}</td
          >
        </tr>
      </table>
    </div>
    <!-- Vaxxinations versus Hospitals table -->

    <!-- Vacinations versus hospitals Bars-->
    <svg {width} {height} class="svgtest">
      <!-- Wards -->

      <text x={offsetLeft - 10} class="chart-label" y={30}> In Wards </text>

      <rect
        x={offsetLeft}
        y={10}
        width={scaleX(ward['fully_vaccinated'])}
        height="30"
        fill="#87B7D4"
      />
      <rect
        x={offsetLeft + scaleX(ward['fully_vaccinated'])}
        y={10}
        width={scaleX(ward['partially_vaccinated'])}
        height="30"
        fill="#ffdb5b"
      />
      <rect
        x={offsetLeft +
          scaleX(ward['fully_vaccinated']) +
          scaleX(ward['partially_vaccinated'])}
        y={10}
        width={scaleX(ward['not_vaccinated'])}
        height="30"
        fill="#D9918F"
      />
      <text
        x={scaleX(+ward['fully_vaccinated']) +
          scaleX(+ward['partially_vaccinated']) +
          scaleX(+ward['not_vaccinated']) +
          offsetLeft +
          10}
        y="30"
      >
        {formatThousands(
          +ward['fully_vaccinated'] +
            ward['partially_vaccinated'] +
            ward['not_vaccinated']
        )}
      </text>

      <!-- High care Case -->
      <text x={offsetLeft - 10} class="chart-label" y={70}> In High Care </text>
      <rect
        x={offsetLeft}
        y={50}
        width={scaleX(highcare['fully_vaccinated'])}
        height="30"
        fill="#87B7D4"
      />
      <rect
        x={offsetLeft + scaleX(highcare['fully_vaccinated'])}
        y={50}
        width={scaleX(highcare['partially_vaccinated'])}
        height="30"
        fill="#ffdb5b"
      />
      <rect
        x={offsetLeft +
          scaleX(highcare['fully_vaccinated']) +
          scaleX(highcare['partially_vaccinated'])}
        y={50}
        width={scaleX(highcare['not_vaccinated'])}
        height="30"
        fill="#D9918F"
      />

      <text
        x={scaleX(+highcare['fully_vaccinated']) +
          scaleX(+highcare['partially_vaccinated']) +
          scaleX(+highcare['not_vaccinated']) +
          offsetLeft +
          10}
        y="70"
      >
        {formatThousands(
          +highcare['fully_vaccinated'] +
            +highcare['partially_vaccinated'] +
            +highcare['not_vaccinated']
        )}
      </text>

      <!-- Intensive Case -->
      <text x={offsetLeft - 10} class="chart-label" y={110}>
        In Intensive Care
      </text>
      <rect
        x={offsetLeft}
        y={90}
        width={scaleX(intensivecare['fully_vaccinated'])}
        height="30"
        fill="#87B7D4"
      />
      <rect
        x={offsetLeft + scaleX(intensivecare['fully_vaccinated'])}
        y={90}
        width={scaleX(intensivecare['partially_vaccinated'])}
        height="30"
        fill="#ffdb5b"
      />
      <rect
        x={offsetLeft +
          scaleX(intensivecare['fully_vaccinated']) +
          scaleX(intensivecare['partially_vaccinated'])}
        y={90}
        width={scaleX(intensivecare['not_vaccinated'])}
        height="30"
        fill="#D9918F"
      />

      <text
        x={scaleX(+intensivecare['fully_vaccinated']) +
          scaleX(+intensivecare['partially_vaccinated']) +
          scaleX(+intensivecare['not_vaccinated']) +
          offsetLeft +
          10}
        y="110"
      >
        {formatThousands(
          +intensivecare['fully_vaccinated'] +
            +intensivecare['partially_vaccinated'] +
            +intensivecare['not_vaccinated']
        )}
      </text>
    </svg>
    <!-- Vacinations versus hospitals Bars-->
  </div>
</div>

<style>
  table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  td {
    border: solid 1px #eee;
  }
  th {
    background: #eeeeee;
    border: solid 1px #fff;
  }
  .chart-label {
    text-anchor: end;
  }
  .latest-date {
    font-size: 80%;
    margin-top: 2px;
    margin-bottom: 3px;
    font-family: 'Titillium Web', Arial, Helvetica, sans-serif;
  }
</style>
